export default {"src":"/_next/static/media/BITVAVO.cee85b24.svg","height":60,"width":374,"blurWidth":0,"blurHeight":0};